import React from "react";
import GetSvgIcon from "../../images/svglist";
import { Tooltip } from "react-tooltip";
import DataTable from "react-data-table-component-with-filter";
import {
  customDataTableStyles,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../Helper/Constants";

const AdvancePaymentList = ({ tableData, openCustAdv }) => {
  const advColumns = [
    {
      name: "Customer",
      selector: (row) => row.business_name + "(" + row.acct_code + ")",
      sortable: true,
      filterable: true,
      // omit: hideColums,
      //
    },
    {
      name: "Total Advance Amount",
      selector: (row) =>
        !!row.adv_amount ? row.adv_amount?.toFixed(2) : "0.00",
      sortable: true,
      filterable: true,
      // omit: hideColums,
    },
    {
      name: "Utilized Advance Amount",
      selector: (row) =>
        !!row.utilize_amount ? row.utilize_amount?.toFixed(2) : "0.00",

      sortable: true,
      filterable: true,
    },
    {
      name: "Available Advance Amount",
      selector: (row) =>
        !!row.available_amount ? row.available_amount?.toFixed(2) : "0.00",
      sortable: true,
      filterable: true,
    },
    {
      name: "",
      cell: (row) => (
        <>
          <div
            data-tooltip-id={"invDTLs-" + row.customer_id}
            className="me-3"
            onClick={() => {
              openCustAdv(row);
            }}
          >
            {GetSvgIcon("PaymentDetails")}
          </div>
          <Tooltip
            id={"invDTLs-" + row.customer_id}
            content="View Details"
            place="left"
          />
        </>
      ),
      allowOverflow: true,
      button: true,
      width: "30px",
    },
  ];
  return (
    <>
      <div className="col-md-12 customized-data-table position-relative">
        {
          <DataTable
            columns={advColumns}
            data={tableData}
            pagination
            striped
            highlightOnHover
            paginationRowsPerPageOptions={defaultRowsPerPageOptions}
            paginationPerPage={defaultPageLimit}
            customStyles={customDataTableStyles}
          />
        }
      </div>
    </>
  );
};

export default AdvancePaymentList;
